export type RecoveryClock = Pick<typeof globalThis, "setTimeout" | "clearTimeout">;

export class WorkflowStepRecoveryScheduler {
  private timer: ReturnType<typeof setTimeout> | null = null;
  private attempts = 0;
  private key = "";
  private generation = 0;
  private inFlight = false;
  private readonly clock: RecoveryClock;

  constructor(clock: RecoveryClock = globalThis) {
    this.clock = clock;
  }

  schedule(key: string, recover: () => Promise<boolean | void> | boolean | void): void {
    if (key !== this.key) {
      this.cancel();
      this.key = key;
      this.attempts = 0;
      this.generation += 1;
    }
    if (this.timer !== null || this.inFlight) return;
    const delay = Math.min(8_000, 1_000 * 2 ** this.attempts);
    this.timer = this.clock.setTimeout(() => {
      this.timer = null;
      this.attempts += 1;
      const generation = this.generation;
      this.inFlight = true;
      Promise.resolve().then(() => generation === this.generation ? recover() : true).then(
        (succeeded) => {
          if (generation !== this.generation) {
            return;
          }
          if (succeeded === false) {
            this.inFlight = false;
            this.schedule(this.key, recover);
            return;
          }
          this.inFlight = false;
        },
        () => {
          if (generation !== this.generation) return;
          this.inFlight = false;
          this.schedule(this.key, recover);
        },
      );
    }, delay);
  }

  cancel(): void {
    if (this.timer !== null) this.clock.clearTimeout(this.timer);
    this.timer = null;
    this.key = "";
    this.attempts = 0;
    this.generation += 1;
    this.inFlight = false;
  }
}
